import React from 'react';
import { playbackUrlFor, trackKey } from '../../../services/studentTracksModel';
import { RECITAL_STATE_TEXT, recitalStatus, refLabel } from '../../../services/trackRolesModel';

/**
 * Each performer's recital track for one set-list song (2026-09-27, build
 * step 6): the list Anthony used to rebuild by hand every spring ("I'm
 * scrambling to get every single student's track in order"). Ready tracks
 * play on the page's one player and download; the rest say why not in words.
 * Chosen from the lesson (the track strip's "Use for recital").
 */
const RecitalTrackLines = ({ entry, song, data, player, studentName }) => {
	if (!data || !data.available || !entry || !(entry.performers || []).length) return null;
	const rows = data.repBySong[entry.canonicalSongId] || [];
	return (
		<ul className="rp-tracks" aria-label={`Recital tracks for ${entry.title || 'this song'}`}>
			{entry.performers.map((studentId) => {
				const rep = rows.find((r) => r.studentId === studentId) || null;
				const st = recitalStatus({ entry: rep, trackDocs: data.docsByStudent[studentId] || [], song });
				const playing = st.file && player && player.isCurrent(st.file) && player.isPlaying;
				return (
					<li key={studentId} className={`rp-track rp-track--${st.state}`}>
						<span className="rp-track__who">{studentName(studentId)}</span>
						{st.state === 'ready' ? (
							<>
								<button
									type="button"
									className={`rp-track__play${playing ? ' is-playing' : ''}`}
									aria-label={`${playing ? 'Pause' : 'Play'} ${studentName(studentId)}'s recital track`}
									onClick={() => player && player.toggle(st.file)}>
									<i className={`fa-sharp fa-solid ${playing ? 'fa-pause' : 'fa-play'}`} aria-hidden="true" />
									{refLabel(st.ref)}
								</button>
								<a className="rp-track__dl" href={playbackUrlFor(st.file)} target="_blank" rel="noopener noreferrer" key={trackKey(st.file)}>
									<i className="fa-sharp fa-solid fa-arrow-down-to-line" aria-hidden="true" />
									Download
								</a>
							</>
						) : (
							<span className="rp-track__state">
								{RECITAL_STATE_TEXT[st.state]}
								{st.state === 'unchosen' ? ` (${st.count} on file)` : ''}
								{st.state === 'missing' && st.ref ? `: ${refLabel(st.ref)}` : ''}
							</span>
						)}
					</li>
				);
			})}
		</ul>
	);
};

/** "5 of 8 performers have a recital track", for the set list's head. */
export const readyCount = (setList = [], data, songsById = {}) => {
	let ready = 0;
	let total = 0;
	if (!data || !data.available) return null;
	for (const entry of setList) {
		const rows = data.repBySong[entry.canonicalSongId] || [];
		for (const studentId of entry.performers || []) {
			total += 1;
			const rep = rows.find((r) => r.studentId === studentId) || null;
			if (recitalStatus({ entry: rep, trackDocs: data.docsByStudent[studentId] || [], song: songsById[entry.canonicalSongId] }).state === 'ready') ready += 1;
		}
	}
	return { ready, total };
};

export default RecitalTrackLines;
